import styled from 'styled-components';

export const SuccessMessage = styled.div`
  background: green;
  padding: 10px;
  border-radius: 10px;
`;
